import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Location } from '@angular/common';
import { MessageService, ConfirmationService } from 'primeng/api';
import { EnfermeraService } from 'src/app/services/enfermera.service';
import { RedimirEnfermera } from 'src/app/models/redimir.interface';
import { environment } from 'src/environments/environment';
import { CANJE } from 'src/app/shared/constantes/constants';

@Component({
  selector: 'app-enfermera-canje-detalle',
  templateUrl: './enfermera-canje-detalle.component.html',
  styleUrls: ['./enfermera-canje-detalle.component.scss'],
  providers: [ConfirmationService, MessageService]
})
export class EnfermeraCanjeDetalleComponent implements OnInit {
  readonly urlbase = environment.urlbase;
  idRedimir!: string;
  idArchivo: number | null = null;
  redimir!: RedimirEnfermera;
  statusCanje: string[] = [...CANJE];


  get cantidad(): number {
    return this.redimir.casosclinicos.reduce((accumulator, item) => accumulator + item.e_puntos, 0);
  }
  constructor(
    private enfermeraService: EnfermeraService,
    private activedRoute: ActivatedRoute,
    private messageService: MessageService,
    private location: Location,
    private confirmationService: ConfirmationService) {

    this.idRedimir = this.activedRoute.snapshot.params['id'];
    this.obtenerInformacion(this.idRedimir);
  }

  ngOnInit(): void {
  }

  canje(id: number): string {
    return this.statusCanje[id];
  }

  obtenerInformacion(id: string): void {
    this.enfermeraService.getRedimirEnfermeraDetalle(id)
      .subscribe({
        next: (resp) => { this.redimir = resp.datos; this.showSuccess(resp.mensaje) },
        error: (err: HttpErrorResponse) => { this.showError(err.error.message) }
      })
  }

  showSuccess(mensaje: string): void {
    this.messageService.add({
      severity: 'success',
      summary: 'Éxito',
      detail: mensaje
    });
  }

  showError(mensaje: string): void {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: mensaje
    });
  }

  getDescripcion(): string {
    return this.statusCanje[this.redimir.status];
  }
}
